import { BasicRequest } from "./basicRequest";

export class DeleteTransformationDefinitionRequest extends BasicRequest{
    public transformationDefinitionId! : number;
    public physicalDelete : boolean = false;
}